const poll = {
  published_colon_date: 'Published: {{date}}',

  /** Quick Poll */
  quick_poll: 'Quick poll',
  converts_the_previous_slide_into_a_poll_question_specify_the_number_of_options_and_publish_to_get_students_responding:
    'Converts the previous slide into a poll question. Specify the number of options and publish to get students responding',

  /** Bar Graph */
  bar_graph: 'Bar graph',
  create_a_rich_poll_question_using_images_math_expressions_and_multiple_options_students_select_one_of_the_options_and_the_results_show_up_as_a_bar_graph:
    'Create a rich poll question using images, math expressions, and multiple options. Students select one of the options and the results show up as a bar graph',

  /** Pie Chart */
  pie_chart: 'Pie chart',
  create_a_rich_poll_question_using_images_math_expressions_and_multiple_options_students_select_one_of_the_options_and_the_results_show_up_as_a_pie_chart:
    'Create a rich poll question using images, math expressions, and multiple options. Students select one of the options and the results show up as a pie chart',

  /** Word cloud */
  word_cloud: 'Word cloud',
  publish_a_discussion_and_see_the_students_responses_in_the_form_of_a_wordcloud:
    "Publish a discussion and see the students' responses in the form of a wordcloud",

  /** Poll Widget */
  untitled_poll: 'Untitled poll',
  question_not_set: 'Question not set',

  /** Polls Form */
  add_a_poll: 'Add a poll',
  create_a_new_poll: '+ Create a new poll',
  use_one_of_the_unpublished_polls: 'Use one of the unpublished polls',
  use_a_previously_added_poll: 'Use a previously added poll',
  there_are_no_unpublished_polls_attached_to_the_lecture_scheduled_at_scheduled_time:
    'There are no unpublished polls attached to the lecture scheduled at {{dateTime}}',
  no_polls_have_been_used_in_presentations_in_any_of_your_courses_yet:
    'No polls have been used in presentations in any of your courses, yet',

  /** Errors */
  unable_to_fetch_polls: 'Unable to fetch polls',

  /** Poll Page */
  course_code_colon_poll_for_lecture_scheduled_at_time_on_date:
    '{{courseCode}}: Poll for lecture scheduled at {{classDateTime}}',

  /** Poll Question */
  enter_your_question_text_here: 'Enter your question text here',
  option_N: 'Option {{num}}',
  click_to_add_rich_text: 'click to add rich text',
  click_to_upload_image: 'click to upload image',
  click_to_clear_value: 'click to clear value',
  click_to_remove_option: 'click to remove option',
  plus_add_another_option: '+ Add another option',

  /**Copy Poll */
  if_you_want_to_reuse_this_poll_in_another_course_or_lecture_you_can_easily_create_a_copy_of_it_it_allows_reusing_the_same_presentation_in_multiple_courses_and_lectures_without_having_to_recreate_the_poll:
    'If you want to reuse this poll in another course or lecture, you can easily create a copy of it. It allows reusing the same presentation in multiple courses and lectures without having to recreate the poll.',
  results_of_the_conducted_poll_remain_accessible_through_acadly_and_the_new_copy_could_be_run_during_the_presentation:
    'Results of the conducted poll remain accessible through Acadly and the new copy could be run during the presentation',

  /** Delete Poll */
  delete_poll: 'Delete poll',
  click_to_delete_poll: 'click to delete poll',
  delete_poll_and_remove_from_slide: 'Delete poll and remove from slide',
  click_to_delete_poll_and_remove_from_slide: 'click to delete poll and remove from slide',
  remove_from_slide: 'Remove from slide',
  click_to_remove_poll_from_this_slide: 'click to remove poll from this slide',
  click_to_cancel_deleting_this_poll: 'click to cancel deleting this poll',

  /** Edit publish preferences and Publish */
  edit_preferences: 'Edit preferences',
  publishing_poll: 'Publishing poll',
  poll_preferences: 'Poll Preferences',
  save_as_default: 'Save as default',
  uncheck_to_not_set_form_values_as_default: 'uncheck to not set form values as default',
  check_to_set_form_values_as_default: 'check to set form values as default',
  click_to_publish_poll: 'clck to publish poll',
  click_to_save_poll_publish_preferences: 'click to save poll publish preferences',
  to_be_done: 'To be done',
  pre_class: 'Pre-class',
  in_class: 'In-class',
  allow_late_submissions: 'Allow late submissions',
  turn_off_to_not_allow_late_submissions: 'turn off to not allow late submissions',
  turn_on_to_allow_late_submissions: 'turn on to allow late submissions',
  late_submissions_will_be_marked_as_late_allowing_for_late_submissions_can_increase_participation:
    'Late submissions will be marked as late allowing for late submissions can increase participation',
  students_wont_be_able_to_respond_to_the_poll_after_the_deadline:
    "Students won't be able to respond to the poll after the deadline",
  withhold_results_till_deadline: 'Withhold results till deadline',
  turn_off_to_declare_results_as_soon_as_submitting_activity:
    'Turn off to declare results as soon as submitting activity',
  turn_on_to_withhold_results_till_deadline: 'Turn on to withhold results till deadline',
  students_will_see_the_poll_results_not_upon_submitting_a_response_but_after_the_poll_deadline_is_over:
    'Students will see the poll results not upon submitting a response but after the poll deadline is over',
  students_will_see_their_scores_and_answers_as_soon_as_they_submit_their_responses:
    'Students will see their scores and answers as soon as they submit their responses',
  the_course_participants_will_be_notified_instantly_via_email_and_push_notifications:
    'The course participants will be notified instantly via email and push notifications',
  once_published_the_poll_cannot_be_deleted: 'Once published the poll cannot be deleted',
  N_seconds_after_publishing: '{{count}} seconds after publishing',
  N_minutes_after_publishing: '{{count}} minutes after publishing',
  when_class_ends: 'When class ends',
  click_to_choose_closes_on: 'click to choose closes on',
  poll_closes: 'Poll closes',
  click_to_close_poll_time: 'click to close poll {{endTime}}',
  student_response: 'Student response',
  click_to_edit_student_responses: 'click to edit student responses',
  click_to_save_student_responses: 'click to save student responses',
  click_to_select_student_response_as_not_anonymous: 'click to select student response as not anonymous',
  click_to_select_student_response_as_anonymous: 'click to select student response as anonymous',
  please_add_a_poll_question_and_try_again: 'Please add a poll question and try again',
  you_can_only_publish_an_activity_in_an_upcoming_or_ongoing_class_that_has_not_been_cancelled_consider_moving_or_copying_this_activity_to_share_it_with_students:
    'You can only publish an activity in an upcoming or ongoing class that has not been cancelled. Consider moving or copying this activity to share it with students.',
  an_in_class_activity_can_only_be_published_during_lecture_hours:
    'An in-class activity can only be published during lecture hours',
  you_can_publish_an_in_class_activity_only_once_it_s_time_for_your_class_and_you_have_started_your_class_on_acadly:
    "You can publish an in-class activity only once it's time for your class and you have started your class on Acadly",
  publish_poll: 'Publish poll',
  this_activity_cannot_be_published_outside_the_scheduled_class_end_time:
    'This activity cannot be published outside the scheduled class end time',

  /** Stop poll */
  stop_poll: 'Stop poll',
  click_to_stop_poll: 'click to stop poll',
  to_avoid_confusion_and_surprised_groans_please_announce_to_the_class_that_you_re_going_to_stop_accepting_responses:
    "To avoid confusion and surprised groans, please announce to the class that you're going to stop accepting responses",
  click_to_cancel_stopping_poll: 'click to cancel stopping poll',
  poll_closed: 'Poll closed',

  /** Published poll */
  total_responses_colon_N: 'Total responses: {{count}}',
  R_of_T_remain: '{{remainingTime}} of {{totalTime}} remain',
  instructor_closes_manually: 'Instructor closes manually',
  results_will_be_visible_once_the_instructor_closes_the_poll:
    'Results will be visible once the instructor closes the poll',
  results_will_be_visible_once_the_poll_closes_in_N:
    'Results will be visible once the poll closes in <2>{{remainingTime}}</2>',

  /** Preview mode */
  poll_cannot_be_published_because_the_lecture_is_over:
    'Poll cannot be published because the lecture is over',
  poll_can_be_published_during_the_lecture: 'Poll can be published during the lecture',
  poll_can_be_successfully_published: 'Poll can be successfully published',
  poll_has_errors_and_cannot_be_published_view_errors:
    'Poll has errors and cannot be published (<1>View errors</1>)',

  please_fix_these_errors_before_publishing_poll: 'Please fix these errors before publishing poll',
  poll_title: 'Poll title',
  question_description: 'Question description',
  question_attachments: 'Question attachments',
  question_options: 'Question options',

  /** Information dialog */
  how_to_participate_in_this_poll: 'How to participate in this poll',
  if_you_re_enrolled_in_the_course_course_code_course_title_that_truncates:
    'If you’re enrolled in the course {{courseCode}}: {{courseTitle}}',
  log_in_to_acadly_app_on_your_mobile_devices_then: 'Log in to Acadly app on your mobile devices, then',
  if_you_don_t_have_an_acadly_account_yet: 'If you don’t have an Acadly account yet',
  look_for_the_invitation_email_from_acadly_in_your_inbox_of_the_email_account_in_which_you_get_emails_from_your_lms:
    'Look for the invitation email from Acadly in your Inbox (of the email account in which you get emails from your LMS)',
  look_for_the_invitation_email_from_acadly_in_your_inbox_please_ask_the_instructor_about_the_email_address_they_used:
    'Look for the invitation email from Acadly in your Inbox (please ask the instructor about the email address they used)',
  please_sign_up_for_acadly_using_your_institute_email_address_and_the_join_code_join_code:
    'Please sign up for Acadly using your institute email address and the join code {{joinCode}}',
  step_1_colon_tap_on_the_course_card: 'Step 1: Tap on the course card',
  step_2_colon_go_to_this_lecture_on_timeline: 'Step 2: Go to this lecture on timeline',
  step_3_colon_tap_on_this_poll: 'Step 3: Tap on this poll',

  /** slide */
  poll_was_not_conducted: 'Poll was not conducted',
  poll_was_published_for_lecture_scheduled_at_date_and_time_url:
    'Poll was published for lecture scheduled at {{dateAndTime}} \r {{url}}',
  poll_published: 'Poll published',
} as const;

export default poll;
